'use strict';

const DEFAULT_TIMEOUT = 5 * 60;
const NULL_ACCOUNT = "GAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWHF";

exports.DEFAULT_TIMEOUT = DEFAULT_TIMEOUT;
exports.NULL_ACCOUNT = NULL_ACCOUNT;
//# sourceMappingURL=types.js.map
